import { render, staticRenderFns } from "./btn_component.vue?vue&type=template&id=7ef37ec9&scoped=true"
import script from "./btn_component.vue?vue&type=script&lang=js"
export * from "./btn_component.vue?vue&type=script&lang=js"
import style0 from "./btn_component.vue?vue&type=style&index=0&id=7ef37ec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef37ec9",
  null
  
)

export default component.exports